<script>
	import Dialog from "../elements/Dialog.svelte";
	import {send_data} from "../client.svelte.js";

	/*** management of the images of a hero: shows all images, deletes single ones and uploads new ones ***/
	// usage: <HeroImages bind:this={manager} id=... hero={...} {disabled}/>, then manager.open() shows the dialog
	let { id = 'hero-images', hero, disabled = false } = $props()

	let imageInput
	let message = $state(null)

	export function open() {
		message = null
		document.getElementById(id).showModal()
	}

	/** Dialog closes on every action, so it is reopened while the file chooser is shown **/
	function choose_images() {
		open()
		imageInput.click()
	}

	async function upload_images(e) {
		e.stopPropagation()		// keeps enclosing forms from treating the file as an attribute change
		const files = Array.from(e.target.files)
		e.target.value = ""		// allows re-selecting the same files
		for (const file of files) {
			try {
				await send_data(`/character/${hero.ID}/image`, {}, 'POST', file)
			} catch (err) {
				console.error(`HERO: image ${file.name} could not be uploaded`, err)
				message = `Bild ${file.name} konnte nicht hochgeladen werden`
			}
		}
	}

	async function delete_image(url) {
		try {
			await send_data(`/character/${hero.ID}/image`, {image: url}, 'DELETE')
		} catch (err) {
			console.error(`HERO: image ${url} could not be deleted`, err)
			message = "Bild konnte nicht gelöscht werden"
		}
	}
</script>

<!-------------------------------- HTML -------------------------------------->

<input bind:this={imageInput} class="hidden" type="file" accept=".jpg, .jpeg, .png, .webp" multiple onchange={upload_images}>

<Dialog {id} title="Bilder von {hero.name || hero.ID}"
        actions={[{id: 'cancel', label: "Schließen"},
                  {id: 'upload', label: "Bilder hochladen", symbol: 'upload', shown: !disabled, func: choose_images}]}>
	<div class="dlg-body">
		{#if message}<p class="error">{message}</p>{/if}
		<div class="imageGrid">
			{#each hero.images ?? [] as url (url)}
				<div class="image">
					<a href={url} target="_blank" title="In neuem Tab öffnen"><img src={url} alt={hero.name}></a>
					{#if !disabled}
						<button class="delete fa icon-trash" title="Bild löschen" aria-label="Bild löschen"
						        tabindex="-1" onclick={() => delete_image(url)}></button>
					{/if}
				</div>
			{:else}
				<p class="empty">Noch keine Bilder vorhanden.</p>
			{/each}
		</div>
	</div>
</Dialog>


<!-------------------------------- STYLE -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	.hidden
		display: none

	.imageGrid
		display: grid
		grid-template-columns: repeat(auto-fill, minmax(160px, 1fr))
		gap: 14px
		min-width: min(560px, 80vw)
		max-height: 60vh
		overflow-y: auto

	.image
		position: relative

		img
			display: block
			width: 100%
			aspect-ratio: 1
			object-fit: cover
			border-radius: 8px
			border: 1px solid colors.$grey-30

		.delete
			position: absolute
			top: 6px
			right: 6px
			margin: 0
			padding: 6px
			border: 0
			border-radius: 6px
			background: rgba(0, 0, 0, 0.65)
			color: colors.$grey-85
			font-size: 12px
			opacity: 0
			cursor: pointer

			&:hover
				color: colors.$white
				background: colors.$highlight-red-060-black

		&:hover .delete, .delete:focus-visible
			opacity: 1

	.empty
		grid-column: 1 / -1
		font-style: italic

	.error
		color: colors.$highlight-red-100
</style>
